/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 16:30:43
 * @LastEditors: caiqin.xie
 * @message: 门店-搜索门店
 */
import React, {useEffect, useState} from "react";
import { Form, Select, Input, Button } from "@arco-design/web-react";
import CarouselShopItem from "../CarouselShopItem";
import Empty from '../Empty'
import styles from "../../index.module.scss";
import request from '@/common/request'
import { DOMAIN_API} from '@/common/const'
import { IShop } from "@/common/types";

interface IProps {
  nearShop: IShop;
  ctry: string;
  areaList: ISelectList[]; // 区域列表
  getList: (query:any)=>void; // 获取门店列表
  words: Record<string, string>;
}

interface ISelectList {
  name: string,
  id: string
}
const FindShop = (props:IProps) => {
  const {ctry, words, nearShop, areaList, getList} = props
  const [countryList, setCountryList] = useState<ISelectList[]>([]) // 国家列表
  const [areaId, setAreaId] = useState<string>() // 区域id
  const [countryId, setCountryId] = useState<string>() // 国家id
  const [keyword, setKeyword] = useState<string>('') // 搜索关键字
  // 获取国家列表
  const getCountryList = (areaId:string) => {
    request.get(`${DOMAIN_API}/o/official/area/getCountryList`, { params: { areaId } })
    .then(res => {
      const {data} = res.data
      setCountryList(data)
    })
    .catch(err => {
      console.log(err)
    })
  }
  return (
    <section className={styles["shop-search"]}>
      <h2>{words?.shop_find_store_title}</h2>
      {/* Find a PICO store near you */}
      <Form autoComplete='off' layout='inline' className={styles["store-search-wrap"]} >
      <div className={styles["store-search-item"]}>
          <span className={styles["store-search-label"]}>{words?.shop_search_areas}</span>
          {/* Areas */}
          <Select
            size='large'
            placeholder={words?.shop_search_select_placeholder}
            onChange={(e) => { setCountryId(undefined); getCountryList(e);setAreaId(e) }}
            allowClear
            value={areaId}
          >
            {areaList.map((option:ISelectList) => (
              <Select.Option key={option.id} value={option.id}>
                {option.name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className={styles["store-search-item"]}>
          <span className={styles["store-search-label"]}>{words?.shop_search_country}</span>
          {/* Urban */}
          <Select
            size='large'
            placeholder={words?.shop_search_select_placeholder}
            allowClear
            value={countryId}
            onChange={(e) => { setCountryId(e) }}
          >
            {countryList.map((option:ISelectList) => (
              <Select.Option key={option.id} value={option.id}>
                {option.name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className={styles["store-search-item"]}>
          <span className={styles["store-search-label"]}>{words?.shop_search_store}</span>
          {/* Store */}
          <Input size='large' placeholder={words?.shop_search_input_placeholder} onChange={(value)=>setKeyword(value)} />
        </div>
        <Button className={styles["store-search-btn"]} onClick={()=>getList({areaId,countryId,keyword})}>{words?.common_search}</Button>
        {/* Search */}
      </Form>
      { nearShop?.id ? (<><div className={styles["store-list"]}>
        <CarouselShopItem carousel={true} shop={nearShop} />
      </div>
      <p className={styles["more-store"]}>
        <a href={`/${ctry}/shop/nearest-shop?areaId=${areaId || ''}&countryId=${countryId || ''}&keyword=${keyword || ''}`}>
          <span className={styles["learn-more-purple"]}>{words?.common_learn_more}</span>
        </a>
        {/* Learn More */}
      </p></>): <Empty words={words}/>}

    </section>
  )
}
export default FindShop
